import React, { Component } from "react";

import { WindowEvent } from "./WindowEvent";

interface IWindowResizerProps {
    onResize: (width: number, height: number) => void;
}

export class WindowResizer extends Component<IWindowResizerProps> {
    public componentDidMount() {
        this.onResize();
    }

    public render() {
        return <WindowEvent type="resize" onEvent={this.onResize} />;
    }

    private onResize = () => {
        this.props.onResize(window.innerWidth, window.innerHeight);
    };
}
